export const parseErrorToArray = error => Object.keys(error)
